import { render, staticRenderFns } from "./CameraChildIntroductionGpdoc.vue?vue&type=template&id=1f297bed&scoped=true&"
import script from "./CameraChildIntroductionGpdoc.vue?vue&type=script&lang=ts&"
export * from "./CameraChildIntroductionGpdoc.vue?vue&type=script&lang=ts&"
import style0 from "./CameraChildIntroductionGpdoc.vue?vue&type=style&index=0&id=1f297bed&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f297bed",
  null
  
)

export default component.exports